import { createContext } from "react";
import { IProductLocationContext } from "../types/productLocation";
  

export const ProductLocationContext = createContext<IProductLocationContext | undefined>(undefined);